var Component = require("enyo/Component"),
    kind      = require("enyo/kind"),
    utils     = require("enyo/utils");

module.exports = kind(/** @lends app.clock.CountdownService.prototype */ {

    /**
     * @private
     */
    name: "app.clock.CountdownService",

    /**
     * @private
     */
    kind: Component,

    /**
     * A hash of named callbacks.
     *
     * @type {Object}
     * @private
     */
    callbacks: null,

    /**
     * The amount of registered callbacks.
     *
     * @type {number}
     * @private
     */
    length: 0,

    /**
     * The timeout that will trigger the executing of the next callback in the
     * queue.
     *
     * @type {timeoutID}
     * @private
     */
    timeoutID: null,

    /**
     * Sets up a hash to store callbacks.
     *
     * @method
     * @private
     */
    importProps: kind.inherit(function(sup) {
        return function() {
            this.euid      = this.euid || utils.uid();
            this.callbacks = {};
            sup.apply(this, arguments);
        };
    }),

    /**
     * @method
     * @private
     */
    constructed: kind.inherit(function(sup) {
        return function() {
            this.tick = this.bindSafely(this.tick);
            sup.apply(this, arguments);
        };
    }),

    /**
     * Request a callback to be executed on the next tick. Automatically starts
     * the clock if needed.
     *
     * @param {string}    name      The name
     * @param {Function}  callback  The callback
     * @public
     */
    request: function(name, callback) {
        if (!this.isScheduled(name)) {
            ++this.length;
        }

        this.callbacks[name] = callback;

        if (this.timeoutID === null) {
            this.timeoutID = setTimeout(this.tick, 1000);
        }
    },

    /**
     * Determines if the named callback is scheduled to be executed on the next
     * tick.
     *
     * @param  {string}   name  The name
     * @return {boolean}  `true` if scheduled, `false` otherwise.
     * @public
     */
    isScheduled: function(name) {
        return Boolean(this.callbacks[name]);
    },

    /**
     * Removes the callback.
     *
     * @param {string}  name  The name
     * @public
     */
    cancel: function(name) {
        if (this.isScheduled(name)) {
            --this.length;
        }

        delete this.callbacks[name];

        if (this.length === 0 && this.timeoutID !== null) {
            clearTimeout(this.timeoutID);
            this.timeoutID = null;
        }
    },

    /**
     * Executes all callbacks on every tick, schedules next tick as needed.
     *
     * @private
     */
    tick: function() {
        var callbacks = this.callbacks,
            name,
            callback;

        this.timeoutID = null;

        /* eslint-disable guard-for-in */
        for (name in callbacks) {
            callback = callbacks[name];
            --this.length;
            delete callbacks[name];
            callback();
        }
        /* eslint-enable guard-for-in */

        if (this.length && this.timeoutID === null) {
            this.timeoutID = setTimeout(this.tick, 1000);
        }
    }

});
